// 対象要素を取得
var $root = $('#newsCategories');
var $button = $root.find('.opener');
var $panel = $root.find('.list');
/**
 * 関数定義
 */
// 初期化処理

var init = function init() {
  var panelId = 'news-categories-panel';
  var buttonId = panelId + '_button'; // デフォルトの属性およびクラスを設定

  $panel.attr({
    'aria-hidden': 'true',
    'id': panelId,
    'aria-labelledby': buttonId
  });
  $button.attr({
    'aria-expanded': 'false',
    'id': buttonId,
    'aria-controls': panelId
  });
}; // 表示切替


var switchDisplay = function switchDisplay(e) {
  // ステートに応じてボタンとパネルの属性値を変更
  if ($button.attr('aria-expanded') === 'false') {
    // 閉じている
    // クリックしたボタンと該当するパネルを開く
    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
  } else {
    // 開いている
    $button.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true');
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
};
/**
 * 初期化処理
 */


init();
/**
 * イベント設定
 */

$button.on('click', switchDisplay); // 領域外クリックで閉じる

if ($root.length) {
  $(document).on('click', function (event) {
    // パネルが開いていて、かつ、領域外をクリックした時の処理
    if (!$(event.target).closest($panel).length && $panel.attr('aria-hidden') === 'false') {
      $button.attr('aria-expanded', 'false');
      $panel.attr('aria-hidden', 'true');
    }
  });
}